// Determines whether the agency Portal nav (Notion-backed pages) is visible to
// the current user. On Branch, gated by the `ShowAgencyPortal` cognito group or
// `isAgency`. Mutual brands (Forreston/Oakwood/CFM) show the Portal to every user
// via the `agencyPortalVisibleToAllUsers` brand feature flag. (#31094, #33024)
export const resolveShowAgencyPortal = ({ showAgencyPortal, isAgency, agencyPortalVisibleToAllUsers }) =>
  !!(agencyPortalVisibleToAllUsers || showAgencyPortal || isAgency);
